// Error codes for lambda.

/**
 * Note: the idea behind these error codes is sound, but
 * the lambda rarely throws known errors.
 * For example, the subdomain in use error will never be thrown
 * since the lambda will blow up before the in-use check
 */

/**
 * @deprecated These are rarely thrown by the lambda
 */
module.exports = {
    UNKNOWN: {
        errorCode: 500,
        errorName: 'UNKNOWN_ERROR'
    },
    INVALID_SUBDOMAIN: {
        errorCode: 400001,
        errorName: 'INVALID_SUBDOMAIN',
        message: 'The given subdomain does not meet DNS requirements.'
    },
    SUBDOMAIN_IN_USE: {
        errorCode: 400002,
        errorName: 'SUBDOMAIN_IN_USE',
        message: 'The given subdomain is already in use.'
    },
    ROUTE53_ERROR: {
        errorCode: 400003,
        errorName: 'ROUTE53_SUBDOMAIN_REGISTRATION_ERROR',
        message: 'An error occurred registering the subdomain via Route53.'
    },
    DB_CONNECTION_ERROR: {
        errorCode: 400004,
        errorName: 'DB_CONNECTION_ERROR',
        message: 'Failed to connect to the database.'
    }
};
